import { useCallback, useEffect, useRef, useState } from "react";
import type { ReactionCounts } from "../../shared/live-protocol";
import { type Mood, QUIET_MOOD, RoomMood, sameMood } from "./room/reactions";

/** The host sees fewer of the room's reactions a second than a viewer does. */
export const HOST_FLOATS_PER_SEC = 4;
export const HOST_FLOATS_ON_SCREEN = 9;
/** The line fades out, changes, and fades back in. */
const MOOD_FADE_MS = 320;

/** The room's last thirty seconds as one line, read once a second and moved on at most every five. */
export function useRoomMood(on: boolean): { heard: (counts: ReactionCounts) => void; mood: Mood; dim: boolean } {
  const [room] = useState(() => new RoomMood());
  const [mood, setMood] = useState<Mood>(QUIET_MOOD);
  const [dim, setDim] = useState(false);
  const shown = useRef(mood);
  useEffect(() => {
    if (!on) return;
    let fade: number | undefined;
    const every = window.setInterval(() => {
      const next = room.line(Date.now());
      if (sameMood(next, shown.current)) return;
      shown.current = next;
      setDim(true);
      window.clearTimeout(fade);
      fade = window.setTimeout(() => {
        setMood(next);
        setDim(false);
      }, MOOD_FADE_MS);
    }, 1000);
    return () => {
      window.clearInterval(every);
      window.clearTimeout(fade);
    };
  }, [on, room]);
  const heard = useCallback((counts: ReactionCounts) => room.hear(Date.now(), counts), [room]);
  return { heard, mood, dim };
}

